<template>
  <svg
    class="size"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 44.38 31.75"
  >
    <path
      class="cls-1"
      d="M44.19,15.16C38.37,5.38,30.56,0,22.19,0S6.01,5.38.2,15.16c-.26.44-.26.99,0,1.43,5.82,9.78,13.63,15.16,21.99,15.16s16.18-5.39,21.99-15.16c.26-.44.26-.99,0-1.43ZM22.19,28.96c-7.14,0-13.92-4.64-19.16-13.08C8.27,7.43,15.05,2.8,22.19,2.8s13.92,4.64,19.16,13.08c-5.24,8.44-12.02,13.08-19.16,13.08Z"
    />
    <path
      class="cls-1"
      d="M27.77,15.09c-.34.1-.7.17-1.07.17-2.15,0-3.89-1.74-3.89-3.89,0-.37.07-.72.17-1.06.3-1.05,1.02-1.9,1.97-2.39-.86-.3-1.78-.47-2.74-.47-4.65,0-8.43,3.78-8.43,8.43s3.78,8.43,8.43,8.43,8.43-3.78,8.43-8.43c0-.97-.17-1.9-.47-2.76-.48.95-1.34,1.67-2.38,1.97Z"
    />
  </svg>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
  }
})
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: currentColor;
  stroke-width: 0;
}
.size {
  width: 1em;
  height: 1em;
}
.lg{
  width: 1.25em;
  height: 1.25em;
}
.sm {
  width: 0.85em;
  height: 0.85em;
}
</style>
